<mat-dialog-content>
  <div class="popup-head">Add categories</div>
  <div>
    <div style="display: grid;grid-template-columns: 1fr 1fr;">
      <div>
        <div class="popup-subhead">{{text}} Name</div>
        <input
          type="text"
          placeholder="Vegan option"
          class="form-control popup-input"
          [(ngModel)]="value"
        />
      </div>
      
      <div>
        <div class="popup-subhead">{{text}} Icon</div>
        <div style="width: 112%; margin-top: 13px">
          <span><img [src]="src" alt="" class="imgPreview" /></span>
          <span style="margin-left: 6%">
            <input type="file" accept="image/png,image/jpeg" (change)="onImageChange($event)" #fileInput_image
              hidden />
            <button class="uploadBtn" (click)="fileInput_image.click()">
              <img src="../../../assets/images/uploadIcon.png" alt="" /><span>Upload</span>
            </button>
          </span>
        </div>
      </div>
      <div style="margin: 20px;" *ngIf="flag">
        <select name="" id="" [(ngModel)]="type" class="form-select">
          <option [value]="item" *ngFor="let item of allTypes">{{item}}</option>
        </select>
      </div>
    </div>
    
  </div>
  <div class="buttomPartAddResto">
    <div (click)="closeDilogFunc()" class="common closeBtn">
      Close
    </div>
    <div (click)="updateDilogFunc()" class="common submitBtn">
      Update
    </div>
  </div>
</mat-dialog-content>
<style>
  ::ng-deep .mat-dialog-container {
    padding: 0;
    overflow-x: hidden;
  }
  
  ::ng-deep .mat-dialog-content::-webkit-scrollbar {
    display: none;
  }
  .popup-head {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    color: rgba(57, 64, 70, 1);
    background-color: rgba(238, 238, 238, 1);
    width: 873px;
    height: 52px;
    display: flex;
    align-items: center;
    padding-left: 25px;
  }
  .popup-subhead {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    color: rgba(23, 83, 117, 1);
    padding-left: 25px;
    margin-top: 20px;
  }
  .popup-input {
    width: 322px;
    margin: 20px;
  }
  .popup-addBtnIcon {
    width: 30px;
    height: 30px;
    margin-top: 64px;
    margin-left: 40px;
    cursor: pointer;
  }
  .buttomPartAddResto {
    display: flex;
    justify-content: end;
  }
  .common {
    padding: 5px 29px;
    margin: 30px 9px;
    cursor: pointer;
    font-family: "Roboto";
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    border-radius: 6px;
  }
  .common:hover {
    box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
      rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
  }

  .closeBtn {
    color: rgba(57, 64, 70, 1);
    border: 2px solid rgba(57, 64, 70, 1);
  }

  .submitBtn {
    color: rgba(255, 255, 255, 1);
    background: linear-gradient(90.17deg, #2fb9e3 -97.61%, #56ab51 120.65%);
    border-radius: 6px;
  }
  .uploadBtn {
    width: 121px;
    height: 41px;
    border-radius: 6px;
    background-color: rgba(84, 172, 88, 1);
    border: none;
  }

  .uploadBtn span {
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: rgba(242, 242, 242, 1);
    padding-left: 10px;
  }

  .imgPreview {
    width: 51px;
    height: 51px;
    border-radius: 25px;
  }
</style>
